export default {
    dark: {
        accessRequiredBackground: ' rgba(255, 255, 255, 0.10)',
        accessRequiredBackgroundHover: 'rgba(0, 49, 104, 0.1)',
        accessRequiredTextHover: '#003168',
        accountRecoveryOptionAltBackground: '#F8F9FB',
        accountRecoveryOptionAltText: '#003168',
        accountRecoveryOptionBackground: '#003168',
        accountRecoveryOptionBorder: '#006AC3',
        actionRequiredBackground: '#050916',
        actionRequiredBackgroundHover: '#101935',
        assetBackground: '#080F25',
        borderBottom: '#FEDF01',
        boxBottom: 'rgba(0,49,104,0.3)',
        boxTop: 'rgba(0,49,104,1)',
        boxTopSecond: 'rgba(0,49,104,1)',
        buttonBorderColor: 'white',
        buttonColor: '#FFFFFF',
        buttonColorHover: '#101935',
        buttonText: '#003168',
        cancelButBackgrounf: '#003168',
        cancelButBorder: 'rgba(255,255,255,0.54)',
        cancelButHover: 'rgba(0,49,104,0.10)',
        cancelButpassOver: '#003168',
        cancelButText: '#FFFFFF',
        canResendLink: '#1A91F9',
        cantScanLink: '#FEDF01',
        cardContent: '#101935',
        cardContentHover: '#050916',
        cardDescription: '#A6A6A6',
        cardDescriptionHover: '#60666D',
        cardImageTextApp: '#FEDF01',
        cardImageTextAppHover: '#FFFFFF',
        cardImageTextRbc: '#FFFFFF',
        cardImageTextRBC: '#FFFFFF',
        cardImageTextRBCHover: '#FEDF01',
        carouselBtn: '#003168',
        carouselBtnHov: '#192753cc',
        checkboxBackground: '#FFFFFF',
        checkboxBackgroundHover: '#003168',
        checkboxBorder: 'rgba(255, 255, 255, 0.54)',
        checkboxBorder2: 'rgba(255, 255, 255, 0.54)',
        checkboxBorderHover: '#2F2F22',
        disabledLinkColor: 'rgba(255,255,255,0.75)',
        divider: 'rgba(255, 255, 255, 0.10)',
        downloadLinkColor: '#FFFFFF',
        entitlementHover: '#FFFFFF',
        errorText: '#F44336',
        errorTitle: '#FFFFFF',
        errorVerbiage: '#A6A6A6',
        factorBackground: '#003168',
        factorEnabletext: '#FFFFFF',
        footerBorder: '#070D1F',
        footerLinkColor: '#FFFFFF',
        footerLinkDesColor: 'rgba(255,255,255,0.54)',
        headerBorder: 'rgba(255, 255, 255, 0.10)',
        insightCard: '#070D1F',
        insightCardHover: '#101935',
        insightsDate: '#60666D',
        languageActive: '#FEDF01',
        languageHoverBackground: 'rgba(254,223,1,0.15)',
        linearProgress: '#757575',
        linkColor: '#FEDF01',
        mfaActiveBackground: '#FFFFFF',
        mobileIcon: '#FEDF01',
        modalBackground: '#080F25',
        moveToTop: '#FEDF01',
        otherProductsBorderColor: '#FFFFFF',
        passButOver: 'rgba(255, 239, 128, 1)',
        passInputField: 'rgba(255,255,255,0.70)',
        passwordCriteriaMet: '#66BB6A',
        passwordCriteriaNotMet: '#60666D',
        passwordDesc: 'rgba(255,255,255,0.75)',
        passwordHintBG: '#30354b',
        passwordOrMFABannerBtn: '#000000',
        passwordOrMFABannerBtnHover: '#FFFFFF',
        passwordPlaceHolder: '#FFFFFF',
        passwordUpdatebanner: '#FFA726',
        passwordUpdatebannerText: '#121212',
        passwordUpdateBtnBorder: 'rgba(0, 0, 0, 0.87)',
        primaryAlternateText: '#003168',
        primaryBackground: '#101935',
        primaryHoverText: '#003168',
        primaryText: '#FFFFFF',
        primaryTextWithAlpha: 'rgba(25,39,83,0.8)',
        productBackground: '#080F25',
        productCardImageText: '#FEDF01',
        profileHr: 'rgba(255,255,255,0.1)',
        profileHr2: '#080F25',
        profileIconBackground: 'rgba(254,223,1,0.15)',
        rbccmPanel: '#080F25',
        rbccmPanelContainer: '#101935',
        recoveryBorder: 'rgba(255, 255, 255, 0.10)',
        recoveryIcon: 'rgba(254, 223, 1, 1)',
        removeButton: 'rgba(255,255,255,0.38)',
        requestSubmitted: '#A6A6A6',
        requestSubmittedHover: '#60666D',
        scrollBarBut: '#FEDF01',
        scrollBarThumb: '#003168',
        scrollBarThumbOver: '#336699',
        scrollBarTrack: '#101935',
        secondaryBackground: '#070D1F',
        secondaryText: '#A6A6A6',
        shieldIcon: '#000000',
        skeletonBackground: '#080F25',
        skeletonInsightsBackground: '#080F25',
        skeletonLogo: '#080F25',
        statusBarStepComplete: '#006AC3',
        statusBarStepInComplete: '#003168',
        subtitleText: '#A6A6A6',
        successText: '#66BB6A',
        successTextLight: '#2E7D32',
        tertiaryBackground: '#080F25',
        timerColor: '#A6A6A6',
        titleColor: '#FFFFFF',
        titleDescription: '#899299',
        userInfoLinkTiles: '#FFFFFF',
        verificationCodeInputFilledBorder: '#006AC3',
        verificationCodeInputUnfilledBorder: 'rgba(255, 255, 255, 0.42)',
        verificationCodeLabel: 'rgba(255, 255, 255, 0.70)',
        verificationNextBtn: '#003168',
        verificationTimer: '#006AC3',
        welcomeCardBorder: 'rgba(255, 255, 255, 0.1)',
        welcomeCardStepLabel: '#FEDF01',
        welcomeCardStepLabelText: '#121212',
    },
    light: {
        accessRequiredBackground: ' rgba(0,49,104,0.10)',
        accessRequiredBackgroundHover: 'rgba(255, 255, 255, 0.10)',
        accessRequiredTextHover: '#FFFFFF',
        accountRecoveryOptionAltBackground: '#003168',
        accountRecoveryOptionAltText: '#FFFFFF',
        accountRecoveryOptionBackground: '#F8F9FB',
        accountRecoveryOptionBorder: '#006AC3',
        actionRequiredBackground: '#FFFFFF',
        actionRequiredBackgroundHover: '#003168',
        assetBackground: '#FFFFFF',
        borderBottom: '#006AC3',
        boxBottom: '#E6EBF0',
        boxTop: '#F2F4F7',
        boxTopSecond: '#FFFFFF',
        buttonBorderColor: 'rgba(0,106,195,0.50)',
        buttonColor: '#006AC3',
        buttonColorHover: '#101935',
        buttonText: '#003168',
        cancelButBackgrounf: '#e0e0e0',
        cancelButBorder: '#e0e0e0',
        cancelButHover: '#bdbdbd',
        cancelButpassOver: '#bdbdbd',
        cancelButText: '#101935',
        canResendLink: '#006AC3',
        cantScanLink: '#006AC3',
        cardContent: '#F8F9FB',
        cardContentHover: '#003168',
        cardDescription: '#60666D',
        cardDescriptionHover: '#F8F9FB',
        cardImageTextApp: '#FFFFFF',
        cardImageTextAppHover: '#003168',
        cardImageTextRbc: '#FFC72C',
        cardImageTextRBC: '#FEDF01',
        cardImageTextRBCHover: '#006AC3',
        carouselBtn: '#F2F4F7',
        carouselBtnHov: '#D1D5DB',
        checkboxBackground: '#003168',
        checkboxBackgroundHover: '#FFFFFF',
        checkboxBorder: 'rgba(0, 0, 0, 0.32)',
        checkboxBorder2: 'rgba(0, 0, 0, 0.54)',
        checkboxBorderHover: 'rgba(255, 255, 255, 0.54)',
        disabledLinkColor: '#FFFFFF',
        divider: '#E1E4E5',
        downloadLinkColor: '#006AC3',
        entitlementHover: '#003168',
        errorText: '#F44336',
        errorTitle: '#003168',
        errorVerbiage: '#60666D',
        factorBackground: '#F8F9FB',
        factorEnabletext: '#9e9e9e',
        footerBorder: '#DADADA',
        footerLinkColor: 'rgba(0,0,0,0.87)',
        footerLinkDesColor: 'rgba(0,0,0,0.54)',
        headerBorder: '#E1E4E5',
        insightCard: '#F8F9FB',
        insightCardHover: '#FFFFFF',
        insightsDate: '#60666D',
        languageActive: '#0051A5',
        languageHoverBackground: 'rgba(0,106,195,0.12)',
        linearProgress: '#BDBDBD',
        linkColor: '#1e99fa',
        mfaActiveBackground: '#003168',
        mobileIcon: 'rgba(0, 106, 195, 1)',
        modalBackground: '#F2F4f7',
        moveToTop: '#003168',
        otherProductsBorderColor: '#003168',
        passButOver: '#004A88',
        passInputField: 'rgba(0, 0, 0, 0.60)',
        passwordCriteriaMet: '#2E7D32',
        passwordCriteriaNotMet: '#A6A6A6',
        passwordDesc: '#252525',
        passwordHintBG: '#FFFFFF',
        passwordOrMFABannerBtn: '#FFFFFF',
        passwordOrMFABannerBtnHover: '#9c9b9bff',
        passwordPlaceHolder: 'rgba(0, 0, 0, 0.87)',
        passwordUpdatebanner: '#ED6C02',
        passwordUpdatebannerText: '#FFFFFF',
        passwordUpdateBtnBorder: 'rgba(0, 0, 0, 0.87)',
        primaryAlternateText: '#FFFFFF',
        primaryBackground: '#FFFFFF',
        primaryHoverText: '#FFFFFF',
        primaryText: '#003168',
        primaryTextWithAlpha: 'rgba(0,49,104,0.10)',
        productBackground: '#FFFFFF',
        productCardImageText: '#FFFFFF',
        profileHr: 'rgba(218,218,218,1)',
        profileHr2: 'rgba(218,218,218,1)',
        profileIconBackground: 'rgba(0,106,195,0.12)',
        rbccmPanel: '#FFFFFF',
        rbccmPanelContainer: '#F2F4F7',
        recoveryBorder: 'rgba(0, 49, 104, 0.10)',
        recoveryIcon: '#003168',
        removeButton: 'rgba(0,0,0,0.50)',
        requestSubmitted: '#60666D',
        requestSubmittedHover: '#F8F9FB',
        scrollBarBut: '#007aff',
        scrollBarThumb: 'rgba(0, 0, 0, 0.12)',
        scrollBarThumbOver: '#007aff',
        scrollBarTrack: 'transparent',
        secondaryBackground: '#F8F9FB',
        secondaryText: '#60666D',
        shieldIcon: '#FFFFFF',
        skeletonBackground: '#FFFFFF',
        skeletonInsightsBackground: '#F8F9FB',
        skeletonLogo: '#F2F4F7',
        statusBarStepComplete: '#006AC3',
        statusBarStepInComplete: '#D9D9D9',
        subtitleText: '#60666D',
        successText: '#2E7D32',
        successTextLight: '#2E7D32',
        tertiaryBackground: '#003168',
        timerColor: '#60666D',
        titleColor: '#0051A5',
        titleDescription: '#899299',
        titleDescription: '#899299',
        userInfoLinkTiles: '#003168',
        verificationCodeInputFilledBorder: '#006AC3',
        verificationCodeInputUnfilledBorder: 'rgba(0, 0, 0, 0.42)',
        verificationCodeLabel: 'rgba(0, 0, 0, 0.60)',
        verificationNextBtn: '#003168',
        verificationTimer: '#006AC3',
        welcomeCardBorder: 'rgba(225, 228, 229, 1)',
        welcomeCardStepLabel: '#006AC3',
        welcomeCardStepLabelText: '#FFFFFF',
    }
}
